export const lightTheme = {
  token: {
    colorBgBase: '#edf1f4',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBgSpotlight: '#17202b',
    colorTextBase: '#17202b',
    colorTextSecondary: '#667383',
    colorBorder: '#d9e0e7',
    colorBorderSecondary: '#e8edf1',
    colorPrimary: '#1875d1',
    colorPrimaryHover: '#0f65bc',
    colorPrimaryActive: '#0c57a4',
    colorSuccess: '#16866a',
    colorWarning: '#b7791f',
    colorError: '#d44a4a',
    colorInfo: '#1875d1',
    borderRadius: 8,
    borderRadiusSM: 7,
    borderRadiusLG: 8,
    controlHeight: 38,
    controlHeightLG: 44,
    controlHeightSM: 30,
    fontSize: 14,
    fontSizeSM: 12,
    fontSizeLG: 16,
    lineHeight: 1.5,
    colorFillTertiary: '#f4f6f8',
    colorFillSecondary: '#e9eef2',
    colorFill: '#dde4ea',
    boxShadow: '0 12px 36px rgba(37, 49, 61, 0.10)',
    boxShadowSecondary: '0 8px 24px rgba(37, 49, 61, 0.08)',
    buttonPrimaryShadow: '0 5px 14px rgba(24, 117, 209, 0.22)',
    buttonDefaultShadow: 'none',
    buttonDangerShadow: 'none',
    wireframe: false,
  },
  components: {
    Button: {
      fontWeight: 600,
      defaultBorderColor: '#d7dfe6',
      defaultColor: '#25313d',
      defaultBg: 'rgba(255, 255, 255, 0.88)',
      primaryShadow: '0 5px 14px rgba(24, 117, 209, 0.22)',
    },
    Card: {
      headerBg: 'transparent',
      headerFontSize: 14,
      headerFontSizeSM: 13,
      paddingLG: 18,
    },
    Tabs: {
      itemColor: '#667383',
      itemHoverColor: '#25313d',
      itemSelectedColor: '#17202b',
      inkBarColor: '#1875d1',
      horizontalItemPadding: '8px 14px',
    },
    Input: {
      activeBorderColor: '#1875d1',
      hoverBorderColor: '#8db8df',
      activeShadow: '0 0 0 3px rgba(24, 117, 209, 0.10)',
    },
    Select: {
      optionSelectedBg: '#eaf3fb',
      activeBorderColor: '#1875d1',
      hoverBorderColor: '#8db8df',
      activeOutlineColor: 'rgba(24, 117, 209, 0.10)',
    },
    Modal: {
      borderRadiusLG: 8,
      titleFontSize: 16,
    },
    Table: {
      headerBg: '#f5f7f9',
      headerColor: '#52606f',
      rowHoverBg: '#f7fafc',
      borderColor: '#e6ebef',
    },
    Tag: {
      borderRadiusSM: 6,
    },
  },
  algorithm: undefined,
};
